import { render, staticRenderFns } from "./NormalSearchNav222.vue?vue&type=template&id=66fddf47&scoped=true&"
import script from "./NormalSearchNav222.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav222.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fddf47",
  null
  
)

export default component.exports